export { c as dgChunkFile } from './chunkFile-c82dbdc0.js';
export { d as alphaNumeric, i as dgInput, e as email, b as maxLength, a as maxValue, c as minLength, m as minValue, p as phoneNumber, r as required } from './validation-a499fe2a.js';
import _extends from '@babel/runtime/helpers/extends';
import React, { useState, useEffect } from 'react';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import ReCAPTCHA from 'react-google-recaptcha';
import Switch from 'react-switch';
import { reduxForm } from 'redux-form';
import 'dg-utils';
import '@babel/runtime/helpers/asyncToGenerator';
import '@babel/runtime/regenerator';

var basicInput = function basicInput(_ref) {
  var input = _ref.input,
    label = _ref.label,
    labelClass = _ref.labelClass,
    placeholder = _ref.placeholder,
    containerClass = _ref.containerClass,
    preventPastDate = _ref.preventPastDate,
    preventFutureDate = _ref.preventFutureDate,
    inputClass = _ref.inputClass,
    type = _ref.type,
    disabled = _ref.disabled,
    autoComplete = _ref.autoComplete,
    _ref$meta = _ref.meta,
    asyncValidating = _ref$meta.asyncValidating,
    touched = _ref$meta.touched,
    error = _ref$meta.error;
    _ref$meta.warning;
  return /*#__PURE__*/React.createElement("div", {
    className: containerClass
  }, label ? /*#__PURE__*/React.createElement("label", {
    className: labelClass ? labelClass : ''
  }, label) : '', /*#__PURE__*/React.createElement("input", _extends({}, input, {
    placeholder: placeholder,
    className: inputClass,
    min: preventPastDate ? new Date().toISOString().split('T')[0] : '',
    max: preventFutureDate ? new Date().toISOString().split('T')[0] : '',
    type: type,
    disabled: disabled,
    autoComplete: autoComplete
  })), /*#__PURE__*/React.createElement("span", {
    className: "form-error"
  }, touched && error || asyncValidating ? error : ''));
};

var select = function select(field) {
  var _field$input3;
  // Documentation on why we need to use this state to control the selected value:
  // https://reactjs.org/docs/forms.html#the-select-tag
  var _useState = useState((field === null || field === void 0 ? void 0 : field.defaultValue) || ""),
    _useState2 = _slicedToArray(_useState, 2),
    selectValue = _useState2[0],
    setSelectValue = _useState2[1];

  // If the default field is updated after initial load, we need to use it to set the value
  // This is due to the fact that this default value may be asynchrnously loaded
  useEffect(function () {
    if (field.defaultValue && field.defaultValue !== "") {
      setSelectValue(field.defaultValue);
      field.input.onChange(field.defaultValue);
    }
  }, [field.defaultValue]);

  // Need to update the select value if the form's value changes
  // This is due to the fact that it was not correctly initialising the
  // select with values from the form (i.e.: it was not picking up
  // the form's value)
  useEffect(function () {
    var _field$input;
    if (((_field$input = field.input) === null || _field$input === void 0 ? void 0 : _field$input.value) !== selectValue) {
      var _field$input2, _field$intput;
      setSelectValue((_field$input2 = field.input) === null || _field$input2 === void 0 ? void 0 : _field$input2.value);
      field.input.onChange((_field$intput = field.intput) === null || _field$intput === void 0 ? void 0 : _field$intput.value);
    }
  }, [(_field$input3 = field.input) === null || _field$input3 === void 0 ? void 0 : _field$input3.value]);
  return /*#__PURE__*/React.createElement("div", {
    className: field.containerClass ? field.containerClass : "field-group",
    style: field.groupStyle ? field.groupStyle : {}
  }, /*#__PURE__*/React.createElement("label", {
    className: field.labelClass
  }, field.label), /*#__PURE__*/React.createElement("div", {
    className: "form-input-container"
  }, field.customSelect ? /*#__PURE__*/React.createElement("div", {
    className: field.customSelect ? field.customSelect : "select"
  }, /*#__PURE__*/React.createElement("select", _extends({
    disabled: field.disabled,
    className: field.inputClass
  }, field.input, {
    value: selectValue,
    onChange: function onChange(e) {
      return setSelectValue(e.target.value);
    }
  }), field.children)) : /*#__PURE__*/React.createElement("select", _extends({}, field.input, {
    className: field.inputClass,
    value: selectValue,
    onChange: function onChange(e) {
      setSelectValue(e.target.value);
      field.input.onChange(e);
    }
  }), field.children), field.meta.touched && field.meta.error && /*#__PURE__*/React.createElement("span", {
    className: "form-error"
  }, field.meta.error)));
};

var checkbox = function checkbox(field) {
  return /*#__PURE__*/React.createElement("div", {
    className: "field-group checkbox",
    style: field.groupStyle ? field.groupStyle : {}
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-input-container"
  }, /*#__PURE__*/React.createElement("input", _extends({}, field.input, {
    type: "checkbox",
    defaultValue: field.defaultValue || false
  })), /*#__PURE__*/React.createElement("label", {
    className: field.labelClass
  }, field.label)), /*#__PURE__*/React.createElement("span", {
    className: "form-error"
  }, field.meta.touched && field.meta.error ? field.meta.error : ''));
};

var radio = function radio(_ref) {
  var input = _ref.input,
    label = _ref.label,
    labelClass = _ref.labelClass,
    groupStyle = _ref.groupStyle,
    inputValue = _ref.inputValue,
    _ref$meta = _ref.meta,
    touched = _ref$meta.touched,
    error = _ref$meta.error;
  return /*#__PURE__*/React.createElement("div", {
    className: "field-group checkbox",
    style: groupStyle ? groupStyle : {}
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-input-container"
  }, /*#__PURE__*/React.createElement("input", _extends({}, input, {
    type: "radio",
    value: inputValue
  })), /*#__PURE__*/React.createElement("label", {
    className: labelClass
  }, label)), /*#__PURE__*/React.createElement("span", {
    className: "form-error"
  }, touched && error ? error : ''));
};

var upload = function upload(field) {
  var files = field.input.value;
  return /*#__PURE__*/React.createElement("div", {
    className: field.containerClass ? field.containerClass : "field-group"
  }, field.label ? /*#__PURE__*/React.createElement("label", {
    className: field.labelClass
  }, field.label) : '', /*#__PURE__*/React.createElement("div", {
    className: "form-input-container"
  }, /*#__PURE__*/React.createElement("input", {
    type: "file",
    multiple: field.multiple ? field.multiple : false,
    accept: field.accept ? field.accept : '.jpg, .png, .jpeg',
    onChange: function onChange(filesToUpload, e) {
      return field.input.onChange(filesToUpload);
    },
    disabled: field.disabled
  }), /*#__PURE__*/React.createElement("span", {
    className: "form-error"
  }, field.meta.touched && field.meta.error ? field.meta.error : '')), /*#__PURE__*/React.createElement("div", {
    className: "container-row uploaded_images"
  }, files && Array.isArray(files) && /*#__PURE__*/React.createElement("ul", null, files.map(function (file, i) {
    return /*#__PURE__*/React.createElement("li", {
      key: i
    }, file.name);
  }))));
};

var inputSelect = function inputSelect(field) {
  return /*#__PURE__*/React.createElement("div", {
    className: field.containerClass
  }, field.label ? /*#__PURE__*/React.createElement("label", {
    className: field.labelClass ? field.labelClass : ''
  }, field.label) : '', /*#__PURE__*/React.createElement("input", _extends({}, field.input, {
    placeholder: field.placeholder,
    className: field.inputClass,
    type: field.type,
    disabled: field.disabled,
    autoComplete: field.autoComplete,
    list: "dg-input-select"
  })), /*#__PURE__*/React.createElement("datalist", {
    id: "dg-input-select"
  }, field.children), /*#__PURE__*/React.createElement("span", {
    className: "form-error"
  }, field.meta.touched && field.meta.error || field.meta.asyncValidating ? field.meta.error : ''));
};

var textarea = function textarea(field) {
  return /*#__PURE__*/React.createElement("div", {
    className: field.containerClass ? field.containerClass : 'field-group',
    style: field.groupStyle ? field.groupStyle : {}
  }, /*#__PURE__*/React.createElement("label", {
    className: field.labelClass
  }, field.label), /*#__PURE__*/React.createElement("div", {
    className: "form-input-container"
  }, /*#__PURE__*/React.createElement("textarea", _extends({}, field.input, {
    disabled: field.disabled,
    maxlength: field.maxLength,
    placeholder: field.placeholder,
    rows: field.rows || 4
  })), /*#__PURE__*/React.createElement("span", {
    className: "form-error"
  }, field.meta.touched && field.meta.error ? field.meta.error : '')));
};

var captcha = function captcha(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "field-group captcha",
    style: props.groupStyle ? props.groupStyle : {}
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-input-container"
  }, /*#__PURE__*/React.createElement(ReCAPTCHA, {
    sitekey: process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY,
    onChange: props.input.onChange
  })), /*#__PURE__*/React.createElement("span", {
    className: "form-error"
  }, props.meta.touched && props.meta.error ? props.meta.error : ''));
};

var toggle = function toggle(field) {
  return /*#__PURE__*/React.createElement("div", {
    className: field.containerClass ? field.containerClass : "field-group toggle"
  }, /*#__PURE__*/React.createElement("label", {
    className: field.labelClass
  }, field.label), /*#__PURE__*/React.createElement("div", {
    className: field.inputContainerClass ? field.inputContainerClass : "form-input-container"
  }, /*#__PURE__*/React.createElement(Switch, _extends({}, field.input, {
    checked: field.input.value,
    onChange: field.input.onChange,
    icons: field.icons || false,
    className: field.inputClass,
    disabled: field.disabled
  }))), (field.meta.touched && field.meta.error || field.meta.asyncValidating) && /*#__PURE__*/React.createElement("div", {
    className: "form-input-container error"
  }, /*#__PURE__*/React.createElement("span", {
    className: "form-error"
  }, "field.meta.error")));
};

var loading = function loading(_ref) {
  var input = _ref.input,
    label = _ref.label,
    containerClass = _ref.containerClass,
    inputContainerClass = _ref.inputContainerClass,
    labelClass = _ref.labelClass,
    value = _ref.value,
    max = _ref.max,
    _ref$meta = _ref.meta,
    asyncValidating = _ref$meta.asyncValidating,
    touched = _ref$meta.touched,
    error = _ref$meta.error;
    _ref$meta.warning;
  return /*#__PURE__*/React.createElement("div", {
    className: containerClass ? containerClass : 'field-group'
  }, /*#__PURE__*/React.createElement("label", {
    className: labelClass
  }, label), /*#__PURE__*/React.createElement("div", {
    className: inputContainerClass ? inputContainerClass : 'form-input-container'
  }, /*#__PURE__*/React.createElement("progress", _extends({}, input, {
    value: value,
    max: max
  }), "".concat(value, "%")), /*#__PURE__*/React.createElement("span", {
    className: "form-error"
  }, touched && error || asyncValidating ? error : '')));
};

var Custom_form = function Custom_form(props) {
  var formClass = props.formClass,
    formHeader = props.formHeader,
    innerContainerClass = props.innerContainerClass,
    headerContainerClass = props.headerContainerClass,
    buttonContainerClass = props.buttonContainerClass,
    fields = props.fields,
    submitText = props.submitText,
    submitClass = props.submitClass,
    handleSubmit = props.handleSubmit;
    props.pristine;
    var submitting = props.submitting,
    onSubmit = props.onSubmit;
  return /*#__PURE__*/React.createElement("form", {
    className: formClass ? formClass : '',
    onSubmit: handleSubmit(onSubmit)
  }, formHeader ? /*#__PURE__*/React.createElement("div", {
    className: headerContainerClass ? "".concat(headerContainerClass) : 'header-container'
  }, formHeader) : '', fields.map(function (field, index, array) {
    return /*#__PURE__*/React.createElement("div", {
      className: innerContainerClass ? "".concat(innerContainerClass) : 'fields-container',
      key: "".concat(index)
    }, field);
  }), /*#__PURE__*/React.createElement("div", {
    className: buttonContainerClass ? "".concat(buttonContainerClass) : 'field-group'
  }, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: submitClass ? "".concat(submitClass) : '',
    disabled: submitting
  }, submitText ? "".concat(submitText) : 'Submit')));
};
Custom_form = reduxForm({
  form: 'Custom_form'
})(Custom_form);

// Custom_form = connect(null,{ })(Login_form);

var CustomForm = Custom_form;

export { CustomForm as DgCustomForm, basicInput as dgBasicInput, checkbox as dgCheckbox, inputSelect as dgInputSelect, loading as dgLoading, radio as dgRadio, captcha as dgRecaptcha, select as dgSelect, textarea as dgTextArea, toggle as dgToggle, upload as dgUpload };
